<template>
  <div
    class="w-100 position-relative bg-white"
    style="min-height: 100vh; margin-bottom: -60px">
    <div id="hotel-room-booking"></div>

    <div
      v-if="getBeCart.room_rate_details.length == 0 || is_redirect"
      class="bg-white text-center"
      style="height: 100vh">
      <div class="ga-container fluid position-relative" style="top: 65px">
        <img src="../../../assets/img/icon/404.png" width="200" />
        <template v-if="is_redirect">
          <p class="pt-3 heading-4 font-bold text-22 mb-2 w-80 mx-auto">
            {{ $t('hotel.error.redirect-to-payment') }}
          </p>
        </template>
        <template v-else>
          <template
            v-if="
              error.payment != '' &&
              error.payment != 'redirect to payment' &&
              error.payment != 'invalid tx id' &&
              error.payment != 'invalid check_in_date'
            ">
            <p class="pt-3 heading-4 font-bold text-22 mb-2 w-80 mx-auto">
              {{ $t('hotel.error.room not available') }}
            </p>
            <p class="body-2 mb-4 w-80 mx-auto">
              {{ $t('hotel.please-choose-another-room') }}
            </p>
          </template>
          <template v-if="error.payment == 'invalid tx id'">
            <p class="pt-3 heading-4 font-bold text-22 mb-2 w-80 mx-auto">
              {{ $t('hotel.error.invalid tx id') }}
            </p>
            <p class="body-2 mb-4 w-80 mx-auto">
              {{ $t('hotel.error.confirm-again-desc') }}
            </p>
          </template>
          <template v-if="error.payment == 'invalid check_in_date'">
            <p class="pt-3 heading-4 font-bold text-22 mb-2 w-80 mx-auto">
              {{ $t('hotel.error.invalid check_in_date') }}
            </p>
            <p class="body-2 mb-4 w-80 mx-auto">
              {{ $t('hotel.Please choose another date') }}
            </p>
          </template>
          <template v-if="error.payment == ''">
            <p class="pt-3 heading-4 font-bold text-22 mb-2 w-80 mx-auto">
              {{ $t('hotel.no-room-selected') }}
            </p>
            <p class="body-2 mb-4 w-80 mx-auto">
              {{ $t('hotel.please-select-the-room-to-be-booked') }}
            </p>
          </template>
        </template>
        <template v-if="!is_redirect">
          <div
            v-if="
              error.payment == '' &&
              error.payment != 'redirect to payment' &&
              error.payment != 'invalid tx id'
            ">
            <button
              type="button"
              class="button-primary px-4 text-14"
              @click="redirectReset()">
              {{ $t('hotel.book-rooms') }}
            </button>
          </div>
          <button
            type="button"
            class="button-primary px-4 text-14"
            v-if="error.payment == 'invalid tx id'"
            @click="reloadPage()">
            {{ $t('hotel.error.confirm-again') }}
          </button>
        </template>
      </div>
    </div>
    <template v-else>
      <!-- <GeneralTopNavbar :steps="steps" :current-step="currentStep" /> -->
      <HotelTopNavbar page="cart" />
      <block :height="80" />
      <!-- HEADER -->
      <!-- <transition name="fade">        
        <cartHeader @toggleStep="toggleStep" :step="cart_step" :is_order_need_payment="is_order_need_payment"></cartHeader>
      </transition> -->

      <!-- INQUIRY -->
      <div class="my-4">
        <HotelCheckoutStepper :steps="steps" :current-step="currentStep" />
      </div>
      <template v-if="cart_step == 1">
        <!-- ROOM DETAIL -->
        <div class="mb-4">
          <cartRoomRateDetail
            @detail="toggleRoomRateDetail"
            @adjustPax="toggleAdjustPax"></cartRoomRateDetail>
          <!-- <div class="w-100">
            <div class="ga-container pb-3">
              <AdditionalServiceProductCart page="SEARCH" />
            </div>
          </div> -->
          <span id="top-section"></span>
        </div>

        <!-- CLAIM REWARD -->
        <template v-if="isMembershipRewardApplied">
          <div class="ga-container fluid">
            <ClaimingReward></ClaimingReward>
          </div>
          <div
            class="w-100 my-4"
            style="height: 8px; background-color: #eee"></div>
        </template>

        <!-- AUTHENTICATION -->
        <template v-if="isNotLogin">
          <div class="ga-container fluid"></div>
          <div
            class="w-100 my-4"
            style="height: 8px; background-color: #eee"></div>
        </template>

        <!-- CONTACT DETAIL -->
        <div class="ga-container fluid">
          <p class="mb-4 body-1-4">{{ $t('hotel.contact-detail.title') }}</p>

          <div
            class="mb-4 rounded-6 bg-white border-form box-shadow-light-aff p-3"
            v-if="isNotLogin">
            <img
              src="../../../assets/img/icon/user.png"
              class="position-relative rounded-100 p-1 object-fit mr-2 d-inline-block w-img-login align-top"
              style="background-color: #cfcfcf" />
            <div class="d-inline-block w-80">
              <p class="mb-0 body-2-2 font-semibold">
                {{ $t('hotel.user.youre-not') }}
                <router-link :to="'/' + getMerchant.code + '/login'"
                  ><span
                    @click="setActiveRoute('cart')"
                    class="underline text-green cursor-pointer body-2-2 font-bold"
                    >{{ $t('hotel.user.login') }}</span
                  ></router-link
                >
                {{ $t('hotel.user.or') }}
                <router-link :to="'/' + getMerchant.code + '/register'"
                  ><span
                    @click="setActiveRoute('cart')"
                    class="underline text-green cursor-pointer body-2-2 font-bold"
                    >{{ $t('hotel.user.register') }}</span
                  ></router-link
                >
              </p>
              <p class="mb-0 body-2 font-regular text-12">
                {{ $t('hotel.user.login-now') }}
              </p>
            </div>
          </div>

          <div class="w-100 mb-3 pb-3 border-b-form-dashed-2">
            <FormGuestDetail
              ref="contact_form"
              viewtype="mobile"></FormGuestDetail>
          </div>
          <div class="w-100" id="middle-section">
            <div class="d-flex mb-2" @click="setBeTicketOwner('me')">
              <div class="mr-3">
                <div class="w-16px rounded-100 border-2-green mt-2px">
                  <div
                    class="w-8px rounded-100 position-relative mx-auto mt-2px"
                    :class="{
                      'bg-green': getBeCart.ticket_owner == 'me',
                    }"></div>
                </div>
              </div>
              <p class="mb-0 body-2 font-regular">
                {{ $t('hotel.contact-detail.iam-guest') }}
              </p>
            </div>
            <div class="d-flex" @click="setBeTicketOwner('other')">
              <div class="mr-3">
                <div class="w-16px rounded-100 border-2-green mt-2px">
                  <div
                    class="w-8px rounded-100 position-relative mx-auto mt-2px"
                    :class="{
                      'bg-green': getBeCart.ticket_owner == 'other',
                    }"></div>
                </div>
              </div>
              <p class="mb-0 body-2 font-regular">
                {{ $t('hotel.contact-detail.iam-not-guest') }}
              </p>
            </div>
          </div>
        </div>
        <div
          class="w-100 my-4"
          style="height: 8px; background-color: #eee"></div>

        <!-- VISITOR DETAIL -->
        <template v-if="getBeCart.ticket_owner == 'other'">
          <div class="ga-container fluid">
            <p class="mb-4 body-1-4">
              {{ $t('hotel.visitor-detail.visitor-detail') }}
            </p>
            <div class="w-100 mb-3">
              <div class="w-100 mb-3">
                <p class="mb-0 body-3">
                  {{ $t('hotel.visitor-detail.full-name') }}
                </p>
                <p class="mb-0 body-2-4">
                  {{ visitor_data.name == '' ? '-' : visitor_data.name }}
                </p>
              </div>
              <div
                class="w-100 mb-3"
                v-if="visitor_data.date_of_birth != 'HIDE'">
                <p class="mb-0 body-3">
                  {{ $t('hotel.visitor-detail.date-of-birth') }}
                </p>
                <p class="mb-1 body-2-4">
                  {{
                    visitor_data.date_of_birth == ''
                      ? '-'
                      : visitor_data.date_of_birth == 'Invalid date'
                      ? visitor_data.date_of_birth
                      : $formatDate(visitor_data.date_of_birth)
                  }}
                </p>
              </div>
              <div class="w-100 mb-3" v-if="visitor_data.country != 'HIDE'">
                <p class="mb-0 body-3">
                  {{ $t('hotel.visitor-detail.country') }}
                </p>
                <p class="mb-1 body-2-4">
                  {{ visitor_data.country == '' ? '-' : visitor_data.country }}
                </p>
              </div>
              <div class="w-100 mb-3" v-if="visitor_data.nationality != 'HIDE'">
                <p class="mb-0 body-3">
                  {{ $t('hotel.visitor-detail.nationality') }}
                </p>
                <p class="mb-1 body-2-4">
                  {{
                    visitor_data.nationality == ''
                      ? '-'
                      : visitor_data.nationality
                  }}
                </p>
              </div>
              <div class="w-100 mb-3">
                <p class="mb-0 body-3">
                  {{ $t('hotel.visitor-detail.phone-number') }}
                </p>
                <p class="mb-1 body-2-4">
                  {{
                    visitor_data.phone_number == ''
                      ? '-'
                      : visitor_data.phone_number
                  }}
                </p>
              </div>
              <div class="w-100 mb-3">
                <p class="mb-0 body-3">
                  {{ $t('hotel.visitor-detail.email') }}
                </p>
                <p class="mb-1 body-2-4">
                  {{ visitor_data.email == '' ? '-' : visitor_data.email }}
                </p>
              </div>
              <div class="w-100">
                <button
                  class="ga-btn-primary-outline-md w-100"
                  @click="toggleVisitorForm()">
                  Edit
                </button>
              </div>
            </div>
            <p
              class="mb-0 mt-2 text-danger body-2 text-12 font-regular delay"
              v-if="!visitor_form_valid">
              {{ $t('hotel.visitor-detail.visitor-information') }}
            </p>
          </div>
          <div
            class="w-100 my-4"
            style="height: 8px; background-color: #eee"></div>
        </template>

        <!-- ADDITIONAL SERVICE -->
        <template v-if="getMerchant.additional_appearance === 'CART'">
          <div class="ga-container fluid">
            <AdditionalService />
          </div>
          <div
            class="w-100 my-4"
            style="height: 8px; background-color: #eee"></div>
        </template>

        <!-- SPECIAL REQUEST -->
        <div class="ga-container fluid">
          <div
            class="d-flex w-100 justify-content-between align-items-start"
            @click="togglePopup('special_request')">
            <div class="mr-3">
              <img src="../../../assets/img/icon/request.png" width="24" />
            </div>
            <div class="w-100 pr-3">
              <p class="mb-0 body-1-4">
                {{ getMerchant.cart_special_request_title }}
              </p>
              <p class="mb-0 body-3-3-1">
                <template v-if="getBeCart.special_request.length == 0">
                  {{ getMerchant.cart_special_request_subtitle }}
                </template>
                <template v-else>
                  {{ $t('hotel.special-request.you-have') }}
                </template>
              </p>
            </div>
            <div>
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <g id="create_24px">
                  <path
                    id="icon/content/create_24px"
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M18.3687 3.29L20.7087 5.63C21.0987 6.02 21.0987 6.65 20.7087 7.04L18.8787 8.87L15.1287 5.12L16.9587 3.29C17.1487 3.1 17.3987 3 17.6587 3C17.9187 3 18.1687 3.09 18.3687 3.29ZM2.99875 17.25V21H6.74875L17.8087 9.94L14.0587 6.19L2.99875 17.25ZM5.91875 19H4.99875V18.08L14.0587 9.02L14.9787 9.94L5.91875 19Z"
                    class="fill-primary" />
                </g>
              </svg>
            </div>
          </div>
          <specialRequestDetail></specialRequestDetail>
        </div>
        <div
          class="w-100 my-4"
          style="height: 8px; background-color: #eee"></div>

        <!-- PROMO CODE -->
        <div class="ga-container fluid">
          <div
            class="d-flex w-100 justify-content-between align-items-start"
            @click="togglePopup('promo_code')">
            <div class="mr-3">
              <img src="../../../assets/img/icon/price-tag.png" width="24" />
            </div>
            <div class="w-100 pr-3">
              <p class="mb-0 body-1-4">
                {{ getMerchant.cart_promo_code_title }}
              </p>
              <p class="mb-0 body-3-3-1">
                {{ getMerchant.cart_promo_code_subtitle }}
              </p>
            </div>
            <div>
              <svg
                width="23"
                height="14"
                viewBox="0 0 23 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M11.4235 14C11.7521 14 12.0807 13.8685 12.3043 13.6187L22.4789 3.19435C22.7023 2.97088 22.8338 2.68167 22.8338 2.35304C22.8338 1.66947 22.321 1.14365 21.6375 1.14365C21.3089 1.14365 21.0066 1.2751 20.783 1.48543L10.7136 11.7784H12.1202L2.05069 1.48543C1.84037 1.2751 1.53802 1.14365 1.19625 1.14365C0.512674 1.14365 0 1.66947 0 2.35304C0 2.68167 0.131456 2.97088 0.354928 3.2075L10.5296 13.6187C10.7793 13.8685 11.0817 14 11.4235 14Z"
                  class="fill-primary" />
              </svg>
            </div>
          </div>
          <div class="mt-3" v-if="getBeFilter.promo_code != ''">
            <promoCodeApplied></promoCodeApplied>
          </div>
        </div>
        <div
          class="w-100 my-4"
          style="height: 8px; background-color: #eee"></div>

        <template v-if="show_guarantee_deposit">
          <div class="ga-container fluid">
            <PaymentOption
              ref="payment_option"
              @submitPaymentOption="submitPaymentOption"
              @changeStatusCC="changeStatusCC"
              @getCreditCardId="getCreditCardId"></PaymentOption>
          </div>
          <div
            class="w-100 my-4"
            style="height: 8px; background-color: #eee"></div>
        </template>
        <div class="ga-container fluid">
          <!-- TERM & CONDITION -->
          <div class="mt-4 pt-2">
            <div
              class="w-16px rounded text-center delay mt-2px mr-2 d-inline-block cursor-pointer text-13 position-relative align-top"
              :class="{ 'bg-orange border-2-orange': term_conditions_check }"
              style="border: 2px solid #9599a0"
              @click="term_conditions_check = !term_conditions_check">
              <img
                src="../../../assets/img/icon/correct-white.png"
                class="position-relative"
                width="10"
                style="top: -6px" />
            </div>
            <p
              class="mb-0 body-2-2 font-regular position-absolute d-inline-block cursor-pointer w-80"
              @click="term_conditions_check = !term_conditions_check">
              {{ $t('hotel.accepted-term-condition') }}
              {{ $t('merchant.term-condition') }}.
            </p>
          </div>
          <div style="height: 35px"></div>

          <!-- ERROR MESSAGE -->
          <div class="p-3 d-block" v-if="error.inquiry != ''">
            <div
              class="p-3 border radius-0 4"
              style="
                background-color: rgb(255, 243, 243);
                border-color: #feb8b8 !important;
              ">
              <div class="row grid-slim-row">
                <div class="col-12 text-center">
                  <p class="mb-0 body-2-2 text-14 font-bold">
                    {{ inquiryError.title }}
                  </p>
                  <p class="mb-0 body-2-2 font-regular text-12">
                    {{ inquiryError.subtitle }}
                  </p>
                  <button
                    v-if="error.inquiry == 'invalid tx id'"
                    type="button"
                    class="button-primary py-2 px-3 text-12 mt-2"
                    @click="reloadPage()">
                    {{ $t('hotel.error.confirm-again') }}
                  </button>
                </div>
              </div>
            </div>
          </div>

          <!-- TOTAL PRICE & BUTTON -->
          <div class="py-2 bg-light-page box-shadow-footer">
            <template>
              <div class="w-100 text-right mb-1 d-inline-block">
                <p
                  class="mb-0 body-2-2 text-14 font-semibold d-inline-block float-left cursor-pointer"
                  @click="popup_active = 'price'">
                  {{ $t('hotel.total-bill') }} :
                </p>
                <p
                  class="mb-0 body-2-2 text-16 font-bold text-orange d-block cursor-pointer"
                  @click="popup_active = 'price'">
                  {{ formatCurrency(total_price) }}
                  <i class="simple-icon-arrow-down text-14"></i>
                </p>
                <!-- <p class="mb-0 body-2 text-12 font-regular d-block">/ reservation</p>  -->
              </div>
              <div class="w-100 text-right mb-1 d-inline-block">
                <p
                  class="mb-0 body-2-2 text-14 d-inline-block float-left cursor-pointer"
                  @click="popup_active = 'price'">
                  {{ $t('hotel.deposit-due-now') }}
                  <template v-if="total_deposit_merchant > 0"
                    >({{
                      getMerchant.deposit_zero_minimum_deposit_value
                    }}%)</template
                  >:
                </p>
                <p
                  class="mb-0 body-2-2 text-16 font-bold d-block cursor-pointer"
                  @click="popup_active = 'price'">
                  {{ formatCurrency(total_deposite_display) }}
                </p>
                <!-- <p class="mb-0 body-2 text-12 font-regular d-block">/ reservation</p>  -->
              </div>
            </template>
            <div class="w-100">
              <state-button
                ref="submitBtnCart"
                block
                :disabled="!term_conditions_check"
                :click="submitAction"
                size="lg"
                variant="secondary">
                {{ button_submit_text }}
              </state-button>
            </div>
          </div>
        </div>
      </template>

      <!-- PAYMENT DETAIL-->
      <template v-else>
        <div class="bg-light-page" style="height: 20px"></div>
        <div class="ga-container fluid bg-light-page pt-3 pb-5">
          <p class="mb-3 body-2-2 text-16 font-bold">
            {{ $t('hotel.reservation-summary') }}
          </p>
          <div class="box-shadow-bold bg-white rounded-6 p-3">
            <div class="w-100 text-left">
              <div class="row slim-grid-row">
                <div class="col-7 mb-2">
                  <p class="mb-0 body-2-2 text-14">
                    {{ getBeCart.qty.room_rate }} {{ $t('hotel.rooms') }} x
                    {{ totalDate }} {{ $t('hotel.night') }}
                  </p>
                </div>
                <div class="col-5 mb-2 text-right">
                  <p class="mb-0 body-2-2 text-14">
                    {{ formatCurrency(getBeRoomSubTotal) }}
                  </p>
                </div>
              </div>
              <div
                class="row slim-grid-row"
                v-if="subtotalAdditionalService > 0">
                <div class="col-7 mb-2">
                  <p class="mb-0 body-2-2 text-14">
                    {{ `${$t('hotel.additional-service')}${totalTaxServiceAdditional > 0 ? '(Incl. Tax)' : ''}` }}
                  </p>
                </div>
                <div class="col-5 mb-2 text-right">
                  <p class="mb-0 body-2-2 text-14">
                    {{ $formatCurrency(subtotalAdditionalService) }}
                  </p>
                </div>
              </div>
              <div class="border-light-top mt-1"></div>
              <div class="row pt-2 mt-1">
                <div class="col-4">
                  <p class="mb-0 body-2-2">
                    {{ $t('hotel.concierge.discount') }}
                  </p>
                </div>
                <div class="col-8 text-right">
                  <p class="mb-0 body-2-2">
                    {{ `${totalDiscount > 0 ? '-' : ''}${$formatCurrency(totalDiscount)}` }}
                  </p>
                </div>
              </div>
              <div class="row">
                <div class="col-4">
                  <p class="mb-0 body-2-2 text-16 font-regular">
                    {{ $t('hotel.total') }}
                  </p>
                </div>
                <div class="col-8 text-right">
                  <p class="mb-0 body-2-2 text-16 font-regular">
                    {{ formatCurrency(total_price) }}
                  </p>
                </div>
              </div>
              <div class="border-light-bottom mt-2 mb-2 pb-1"></div>
              <template v-if="payment_surcharge > 0">
                <div class="row slim-grid-row">
                  <div class="col-7 mb-2">
                    <p class="mb-0 body-2-2 text-14">
                      {{ $t('hotel.payment-surcharge') }}
                    </p>
                  </div>
                  <div class="col-5 mb-2 text-right">
                    <p class="mb-0 body-2-2 text-14">
                      {{ formatCurrency(payment_surcharge) }}
                    </p>
                  </div>
                </div>
              </template>
              <div class="row slim-grid-row">
                <div class="col-7 mb-2">
                  <p
                    class="mb-0 body-2-2"
                    :class="{
                      'text-16 font-bold': total_deposite_display > 0,
                    }">
                    {{ $t('hotel.deposit-due-now') }}
                  </p>
                </div>
                <div class="col-5 mb-2 text-right">
                  <p
                    class="mb-0 body-2-2"
                    :class="{
                      'text-16 font-bold': total_deposite_display > 0,
                    }">
                    {{ formatCurrency(total_deposite_display) }}
                  </p>
                </div>
              </div>
              <div class="row slim-grid-row">
                <div class="col-7">
                  <p class="mb-0 body-2-2 text-14">
                    {{ $t('hotel.deposit-due-on-arrival') }}
                  </p>
                </div>
                <div class="col-5 text-right">
                  <p class="mb-0 body-2-2 text-14">
                    {{ formatCurrency(total_non_deposit) }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="ga-container fluid" v-if="show_xendit_cc_form">
          <XenditInputCC
            :tx_payment="tx_payment"
            @done="clearCart"
            @done-destroyed="toggleClearCartDestroyed"
            @expired="closeXenditCC">
          </XenditInputCC>
        </div>

        <!-- Payment Methods -->
        <div
          v-else
          class="ga-container fluid bg-light-page px-4 py-2"
          style="margin-bottom: -60px">
          <div v-if="pm_loader" class="w-100 my-5 text-center">
            <loader />
          </div>
          <template v-else>
            <div class="p-3 d-block" v-if="error.payment_list != ''">
              <div
                class="p-3 border radius-0"
                style="
                  background-color: rgb(255, 243, 243);
                  border-color: #feb8b8 !important;
                ">
                <div class="row grid-slim-row">
                  <div class="col-12 text-center">
                    <p class="mb-0 body-3-1">{{ error.payment_list }}</p>
                  </div>
                </div>
              </div>
            </div>
            <template v-else>
              <p class="mb-2 body-2-2 text-16 font-bold">
                {{ $t('hotel.payment-method.choose-payment-method') }}
              </p>
              <p
                class="mb-4 body-2-2 text-14 font-regular"
                v-html="getMerchant.payment_description"></p>
              <div
                class="mb-3 px-3 py-2 rounded-6 delay cursor-pointer box-shadow-bold overflow-hidden"
                :class="{
                  'border-green': pm.is_selected,
                  'bg-white': !pm.is_selected,
                  'bg-light-page h-auto': pm.is_selected,
                }"
                v-for="(pm, index) in payment_methods"
                @click="togglePayment(index)"
                style="height: 70px; background-color: #fff">
                <div class="row no-gutters pt-1">
                  <div class="col-1">
                    <div
                      class="w-16px rounded-100 border-2-green"
                      style="margin-top: 12px">
                      <div
                        class="w-8px rounded-100 position-relative mx-auto mt-2px"
                        :class="{ 'bg-green': pm.is_selected }"></div>
                    </div>
                  </div>
                  <div class="col-8">
                    <div class="pr-2">
                      <p
                        class="mb-0 ml-2 body-2-2 font-bold text-16"
                        :class="{ 'pt-2': pm.is_selected }"
                        style="line-height: 1 !important">
                        {{ pm.data.name }}
                      </p>
                      <span
                        v-if="
                          pm.data.bank_name == 'DIRECT_PAYMENT' ||
                          (pm.data.bank_name == 'WISE' &&
                            pm.data.payment_method == 'BANK_TRANSFER')
                        "
                        class="body-3-3-2 mb-0 ml-2 text-orange d-block"
                        >{{ $t('general.manually-checked') }}</span
                      >
                      <span
                        v-else
                        class="body-3-3-2 mb-0 ml-2 text-green d-block"
                        >{{ $t('general.checked-automatically') }}</span
                      >
                      <p
                        class="mb-0 pb-2 ml-2 body-2-2 text-12 text-truncate"
                        v-if="!pm.is_selected"
                        v-html="pm.data.description"></p>
                    </div>
                  </div>
                  <div class="col-3 text-right">
                    <img
                      :src="pm.data.image_url"
                      style="
                        max-width: 100%;
                        height: 40px;
                        object-fit: contain;
                      " />
                  </div>
                  <div class="col-12 mt-2" v-if="pm.is_selected">
                    <p
                      class="mb-0 body-2-2 pb-2 text-12 html-desc"
                      v-html="pm.data.description"></p>
                  </div>
                </div>
              </div>
              <!-- ERROR MESSAGE -->
              <div class="p-3 d-block" v-if="error.payment != ''">
                <div
                  class="p-3 border radius-0"
                  style="
                    background-color: rgb(255, 243, 243);
                    border-color: #feb8b8 !important;
                  ">
                  <div class="row grid-slim-row">
                    <div class="col-12 text-center">
                      <p class="mb-0 body-3-1">{{ error.payment }}</p>
                    </div>
                  </div>
                </div>
              </div>
              <state-button
                ref="submitBtnCart"
                block
                :disabled="!is_payment_valid"
                :click="submitPayment"
                size="lg"
                variant="secondary">
                {{ $t('general.payment') }}
              </state-button>
            </template>
          </template>
        </div>
      </template>

      <!-- POPUP -->
      <template>
        <!-- FORM CONTACT DETAIL -->
        <transition name="fade">
          <template
            v-if="
              popup_active == 'contact_detail' ||
              popup_active == 'visitor_detail'
            ">
            <cartContactDetail
              :type="contact_type"
              @close="togglePopup"></cartContactDetail>
          </template>
        </transition>

        <!-- ADDITIONAL SERVICE ITEM -->
        <!-- <template v-if="popup_active == 'additional_service'">
          <additionalService @close="togglePopup" :is_uncategorized="is_additional_service_uncategorized"></additionalService>
        </template> -->

        <!-- ADDITIONAL SERVICE DETAIL -->
        <!-- <template v-if="popup_active == 'additional_service_service'">
          <additionalServiceDetail :data="selected_data_additional_service" @close="togglePopup"></additionalServiceDetail>
        </template> -->

        <!-- SPECIAL REQUEST ITEM -->
        <transition name="fade">
          <template v-if="popup_active == 'special_request'">
            <specialRequest @close="togglePopup"></specialRequest>
          </template>
        </transition>

        <!-- PROMO CODE -->
        <transition name="fade">
          <template v-if="popup_active == 'promo_code'">
            <promoCode @close="togglePopup"></promoCode>
          </template>
        </transition>

        <!-- DETAIL PRICE LIST  -->
        <transition name="fade">
          <template v-if="popup_active == 'price'">
            <div class="position-relative" style="z-index: 1037">
              <div class="row no-gutters justify-content-center">
                <div
                  class="fixed-bottom d-block nav-bottom"
                  style="bottom: 0px">
                  <div class="custom-container-fluid px-0">
                    <div class="row justify-content-center no-gutters">
                      <div
                        class="col-xl-4 col-lg-4 col-md-6 col-sm-8 col-12 position-relative">
                        <div
                          class="container px-4 py-3 bg-white box-shadow-footer">
                          <div class="mb-3 pb-1">
                            <img
                              src="../../../assets/img/icon/close.png"
                              class="my-2 d-inline-block mr-2 cursor-pointer"
                              width="15"
                              @click="popup_active = 'close'" />
                            <p
                              class="mb-0 body-2-2 text-16 font-bold d-inline-block">
                              {{ $t('hotel.reservation-summary') }}
                            </p>
                          </div>
                          <div class="scroll-hide-mobile">
                            <div class="w-100 text-left">
                              <div class="row slim-grid-row">
                                <div class="col-7 mb-2">
                                  <p class="mb-0 body-2-2">
                                    {{ getBeCart.qty.room_rate }}
                                    {{
                                      $t(
                                        'hotel.unit-type.' +
                                          getBeRoomTypeSummaryType +
                                          '.unit'
                                      )
                                    }}
                                    x {{ totalDate }} {{ $t('hotel.night') }}
                                  </p>
                                </div>
                                <div class="col-5 mb-2 text-right">
                                  <p class="mb-0 body-2-2">
                                    {{ formatCurrency(getBeRoomSubTotal) }}
                                  </p>
                                </div>
                              </div>
                              <div
                                class="row slim-grid-row"
                                v-if="subtotalAdditionalService > 0">
                                <div class="col-7 mb-2">
                                  <p class="mb-0 body-2-2">
                                    {{ `${$t('hotel.additional-service')}${totalTaxServiceAdditional > 0 ? '(Incl. Tax)' : ''}` }}
                                  </p>
                                </div>
                                <div class="col-5 mb-2 text-right">
                                  <p class="mb-0 body-2-2">
                                    {{
                                      formatCurrency(subtotalAdditionalService)
                                    }}
                                  </p>
                                </div>
                              </div>
                              <div class="border-light-top mt-1"></div>
                              <div class="row pt-2 mt-1">
                                <div class="col-4">
                                  <p class="mb-0 body-2-2">
                                    {{ $t('hotel.concierge.discount') }}
                                  </p>
                                </div>
                                <div class="col-8 text-right">
                                  <p class="mb-0 body-2-2">
                                    {{ `${totalDiscount > 0 ? '-' : ''}${$formatCurrency(totalDiscount)}` }}
                                  </p>
                                </div>
                              </div>
                              <div class="row pt-2">
                                <div class="col-4">
                                  <p class="mb-0 body-2-2 text-16 font-regular">
                                    {{ $t('hotel.total') }}
                                  </p>
                                </div>
                                <div class="col-8 text-right">
                                  <p class="mb-0 body-2-2 text-16 font-regular">
                                    {{ formatCurrency(total_price) }}
                                  </p>
                                </div>
                              </div>
                              <div
                                class="border-light-bottom mt-2 mb-2 pb-1"></div>
                              <template>
                                <div class="row slim-grid-row">
                                  <div class="col-7 mb-2">
                                    <p class="mb-0 body-2-2 font-bold text-16">
                                      {{ $t('hotel.deposit-due-now') }}
                                      <template
                                        v-if="total_deposit_merchant > 0"
                                        >({{
                                          getMerchant.deposit_zero_minimum_deposit_value
                                        }}%)</template
                                      >
                                    </p>
                                  </div>
                                  <div class="col-5 mb-2 text-right">
                                    <p class="mb-0 body-2-2 font-bold text-16">
                                      {{
                                        formatCurrency(total_deposite_display)
                                      }}
                                    </p>
                                  </div>
                                </div>
                                <div class="row slim-grid-row">
                                  <div class="col-7 mb-2">
                                    <p class="mb-0 body-2-2">
                                      {{ $t('hotel.deposit-due-on-arrival') }}
                                    </p>
                                  </div>
                                  <div class="col-5 mb-2 text-right">
                                    <p class="mb-0 body-2-2">
                                      {{ formatCurrency(total_non_deposit) }}
                                    </p>
                                  </div>
                                </div>
                              </template>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </transition>
        <transition name="fade">
          <template
            v-if="
              popup_active != 'close' ||
              terms_conditions ||
              error.inquiry == 'invalid tx id' ||
              error.inquiry == 'invalid check_in_date' ||
              popup_deposit == 'show'
            ">
            <PopUpBackground @click="toggleRoomRateDetail"></PopUpBackground>
          </template>
        </transition>

        <!-- ROOM POPUP DETAIL-->
        <template v-if="popup_active == 'room_rate'">
          <transition name="fade">
            <roomRateDetail
              :show_img="true"
              :data="selected_room_rate"
              @close="toggleRoomRateDetail"></roomRateDetail>
          </transition>
        </template>
      </template>

      <template v-if="terms_conditions">
        <transition name="fade">
          <TermsConditions
            @togglePopUp="toggleTermsConditions"></TermsConditions>
        </transition>
      </template>

      <!-- INVALID PAX -->
      <popup-detail
        id_ref="invalid_pax"
        direction="bottom"
        :show="invalid_pax.show"
        use_max_size
        wrapper_size="mobile"
        use_footer
        no_close_backdrop
        @close="toggleInvalidPax">
        <template v-slot:body>
          <div class="py-5 px-4 text-center" v-if="invalid_pax.show">
            <div class="rounded-100 my-2 w-20 mx-auto">
              <div class="bg-warning rounded-100 mx-auto size-icon-in">
                <div class="pt-3">
                  <svg
                    width="38"
                    height="32"
                    viewBox="0 0 38 32"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M0.666672 31.8333L19 0.166656L37.3333 31.8333H0.666672ZM31.55 28.5L19 6.81666L6.45001 28.5H31.55ZM17.3333 23.5V26.8333H20.6667V23.5H17.3333ZM17.3333 13.5H20.6667V20.1667H17.3333V13.5Z"
                      fill="white" />
                  </svg>
                </div>
              </div>
            </div>
            <p class="mb-0 body-2-2 text-18 text-green font-extrabold">
              Incomplete data
            </p>
            <p class="mb-2 body-2-2">
              In the <b>{{ invalid_pax.data }}</b> the total number of guests
              staying is still 0, please complete the total number of guests in
              that room
            </p>
          </div>
        </template>
        <template v-slot:footer>
          <div class="px-3 pt-3">
            <button @click="openAdjustPaxFromWarning" class="ga-btn-primary-lg">
              Check Room Pax
            </button>
          </div>
        </template>
      </popup-detail>

      <!-- Pop Up Warning -->
      <template
        v-if="
          error.inquiry == 'invalid tx id' ||
          error.inquiry == 'invalid check_in_date' ||
          error.inquiry == 'invalid email address' ||
          error.payment == 'invalid email address'
        ">
        <div class="w-100">
          <transition name="fade">
            <div class="position-relative z-index-1045">
              <div class="row no-gutters justify-content-center">
                <div class="fixed-bottom d-block nav-bottom" style="top: 20%">
                  <div class="custom-container-fluid px-0">
                    <div class="row justify-content-center no-gutters">
                      <div
                        class="col-xl-4 col-lg-5 col-md-5 col-sm-8 col-10 position-relative">
                        <div class="bg-white rounded-6">
                          <div class="w-100 py-4">
                            <div
                              class="container px-4 text-center position-relative">
                              <div class="mb-3 mx-auto">
                                <div class="mx-auto">
                                  <img
                                    src="../../../assets/img/icon/404.png"
                                    width="170" />
                                </div>
                              </div>
                              <div class="pb-3">
                                <template
                                  v-if="
                                    error.inquiry == 'invalid check_in_date'
                                  ">
                                  <p
                                    class="mb-0 body-2-2 text-20 font-extrabold">
                                    {{
                                      $t('hotel.error.invalid check_in_date')
                                    }}
                                  </p>
                                  <p class="mb-1 body-2-2 font-regular text-14">
                                    {{ $t('hotel.Please choose another date') }}
                                  </p>
                                  <router-link
                                    :to="'/' + getMerchant.code + '/booking'">
                                    <button
                                      type="button"
                                      class="button-primary py-2 px-3 text-12 mt-2">
                                      {{ $t('hotel.choose-another-date') }}
                                    </button>
                                  </router-link>
                                </template>
                                <template
                                  v-if="
                                    error.inquiry == 'invalid email address' ||
                                    error.payment == 'invalid email address'
                                  ">
                                  <p
                                    class="mb-0 body-2-2 text-20 font-extrabold">
                                    {{
                                      $t('hotel.error.invalid-email-address')
                                    }}
                                  </p>
                                  <p class="mb-1 body-2-2 font-regular text-14">
                                    {{
                                      $t(
                                        'hotel.error.invalid-email-address-desc'
                                      )
                                    }}
                                  </p>
                                  <button
                                    type="button"
                                    class="button-primary py-2 px-3 text-12 mt-3"
                                    @click="reloadPage()">
                                    {{ $t('hotel.error.confirm-again') }}
                                  </button>
                                </template>
                                <!-- <template v-if="error.inquiry == 'invalid tx id'">
                                <p class="mb-0 body-2-2 text-20 font-extrabold">{{$t("hotel.error.invalid tx id")}}</p>
                                <p class="mb-0 body-2-2 font-regular text-14 mt-2">{{$t("hotel.error.confirm-again-desc")}}</p>
                                <button type="button" class="button-primary py-2 px-3 text-12 mt-3" @click="reloadPage()">{{$t("hotel.error.confirm-again")}}</button>
                              </template> -->
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </transition>
        </div>
      </template>
      <template v-if="cart_step == 1 && error.payment != ''">
        <WarningBox
          title="Transaction Failed"
          :body="error.payment"
          btn_primary="Close"
          @yes="clearPaymentError">
        </WarningBox>
      </template>

      <!-- POPUP DEPOSIT 0 -->
      <transition name="fade">
        <template v-if="popup_deposit == 'show' && error.inquiry == ''">
          <div class="w-100">
            <div class="position-relative z-index-1045">
              <div class="row no-gutters justify-content-center">
                <div class="fixed-bottom d-block nav-bottom" style="top: 25%">
                  <div class="custom-container-fluid px-0">
                    <div class="row justify-content-center no-gutters">
                      <div
                        class="col-xl-4 col-lg-5 col-md-5 col-sm-8 col-12 position-relative">
                        <div class="bg-white mx-4 rounded-6">
                          <div class="w-100 py-4">
                            <div
                              class="container px-4 text-center position-relative">
                              <p class="mb-1 body-2-2 text-18 font-extrabold">
                                {{
                                  $t(
                                    'hotel.Are you sure to create this reservation?'
                                  )
                                }}
                              </p>
                              <p class="mb-3 body-2-2 font-regular text-14">
                                {{
                                  $t(
                                    'hotel.Make sure you choose the best offer'
                                  )
                                }}
                              </p>
                              <div class="row">
                                <div class="col-4">
                                  <button
                                    class="g-btn g-btn-light g-btn-lg mb-3 w-100"
                                    @click="
                                      deposit_warning = false;
                                      popup_deposit = false;
                                    ">
                                    {{ $t('general.back') }}
                                  </button>
                                </div>
                                <div class="col-8">
                                  <state-button
                                    :disabled="button_submit_not_valid"
                                    :click="submitWithZeroDeposit"
                                    size="lg"
                                    block
                                    variant="secondary">
                                    {{ $t('ticket-cart.continue') }}
                                  </state-button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
      </transition>

      <span
        id="hotel-room-booking-bottom"
        class="position-relative"
        style="bottom: -300px"></span>
    </template>
    <form
      :action="dkpayload.URL"
      method="post"
      id="dkpayform2018"
      name="dkpayform2018"
      ref="FormDKload">
      <input name="MALLID" type="hidden" v-model="dkpayload.MALLID" />
      <input name="BASKET" type="hidden" v-model="dkpayload.BASKET" />
      <input
        name="CHAINMERCHANT"
        type="hidden"
        v-model="dkpayload.CHAINMERCHANT" />
      <input name="AMOUNT" type="hidden" v-model="dkpayload.AMOUNT" />
      <input
        name="PURCHASEAMOUNT"
        type="hidden"
        v-model="dkpayload.PURCHASEAMOUNT" />
      <input
        name="TRANSIDMERCHANT"
        type="hidden"
        v-model="dkpayload.TRANSIDMERCHANT" />
      <input name="WORDS" type="hidden" v-model="dkpayload.WORDS" />
      <input name="CURRENCY" type="hidden" v-model="dkpayload.CURRENCY" />
      <input
        name="PURCHASECURRENCY"
        type="hidden"
        v-model="dkpayload.PURCHASECURRENCY" />
      <input name="COUNTRY" type="hidden" v-model="dkpayload.COUNTRY" />
      <input name="SESSIONID" type="hidden" v-model="dkpayload.SESSIONID" />
      <input
        name="PAYMENTCHANNEL"
        type="hidden"
        v-model="dkpayload.PAYMENTCHANNEL" />
      <input
        name="REQUESTDATETIME"
        type="hidden"
        v-model="dkpayload.REQUESTDATETIME" />
      <input name="NAME" type="hidden" v-model="dkpayload.NAME" />
      <input name="EMAIL" type="hidden" v-model="dkpayload.EMAIL" />
      <input name="ADDRESS" type="hidden" v-model="dkpayload.ADDRESS" />
      <input name="MOBILEPHONE" type="hidden" v-model="dkpayload.MOBILEPHONE" />
    </form>

    <popup-detail
      id_ref="adjust_pax"
      direction="bottom"
      :show="adjust_pax.show"
      use_max_size
      wrapper_size="mobile"
      title="Adjust Pax"
      @close="toggleAdjustPax"
      no_close_backdrop>
      <template v-slot:body>
        <AdjustPax
          v-if="adjust_pax.data.guest"
          :data="adjust_pax.data"
          @close="toggleAdjustPax"
          @openDetail="toggleRoomRateDetail"></AdjustPax>
      </template>
    </popup-detail>

    <!-- VISITOR FORM -->
    <popup-detail
      id_ref="visitor-form"
      direction="bottom"
      :show="visitor_form"
      use_max_size
      wrapper_size="mobile"
      title="Visitor contact detail"
      @close="toggleVisitorForm"
      use_footer
      no_close_backdrop>
      <template v-slot:body>
        <div class="px-4" :key="visitor_form_key">
          <FormGuestDetail
            ref="contact_visitor_form"
            guest_type="someone"
            viewtype="mobile"></FormGuestDetail>
        </div>
      </template>
      <template v-slot:footer>
        <div class="p-4">
          <state-button
            variant="primary"
            size="lg"
            block
            :click="saveVisitorForm">
            Save
          </state-button>
        </div>
      </template>
    </popup-detail>
  </div>
</template>
<script>
import { mapGetters, mapMutations } from 'vuex';
import { formatCurrency, paymentMethodConverter } from '@/utils/index.js';
import { post, get } from '@/services/index.js';
import config from '@/config/index.js';
import RoomTypeDetailMobile from '@/components/dev/RoomTypeDetailMobile';
import PopUpBackground from '@/components/dev/PopUpBackground';
import paypal from '../../../assets/img/hotel/paypal.png';
import credit_card from '../../../assets/img/hotel/mastercard.png';
import bank_transfer from '../../../assets/img/hotel/bank-transfer.png';

// fix
import TermsConditions from '@/components/hotel/be/desktop/termsConditions.vue';
import AdditionalService from '@/components/hotel/be/additionalService';
import specialRequest from '@/components/hotel/be/mobile/specialRequest';
import specialRequestDetail from '@/components/hotel/be/mobile/specialRequestDetail';
import promoCode from '@/components/hotel/be/mobile/promoCode';
import promoCodeApplied from '@/components/hotel/be/mobile/promoCodeApplied';
import cartRoomRateDetail from '@/components/hotel/be/mobile/cartRoomRateDetail';
import roomRateDetail from '@/components/hotel/be/mobile/roomRateDetail';
import cartContactDetail from '@/components/hotel/be/mobile/cartContactDetail';
import cartHeader from '@/components/hotel/be/mobile/cartHeader';
import DokuForm from '@/components/ticket/DokuForm';
import XenditInputCC from '@/components/hotel/be/XenditInputCC';
import moment from 'moment';
import Form from '../../../base';
import WarningBox from '@/components/general/WarningBox';
import PaymentOption from '@/components/hotel/be/PaymentOption';
import AdjustPax from '../../../components/hotel/be/AdjustPax.vue';
import ClaimingReward from '@/components/hotel/general/ClaimingReward.vue';
import FormGuestDetail from '../../../components/hotel/be/FormGuestDetail';
import AdditionalServiceProductCart from '@/components/hotel/be/additionalService/ProductCart';
import GeneralTopNavbar from '../../../components/general/GeneralTopNavbar.vue';
import HotelTopNavbar from '../../../components/hotel/HotelTopNavbar.vue';
import HotelCheckoutStepper from '../../../components/hotel/be/HotelCheckoutStepper.vue';

export default {
  components: {
    TermsConditions,
    RoomTypeDetailMobile,
    PopUpBackground,
    AdditionalService,
    specialRequest,
    specialRequestDetail,
    cartRoomRateDetail,
    roomRateDetail,
    cartContactDetail,
    cartHeader,
    DokuForm,
    promoCode,
    promoCodeApplied,
    XenditInputCC,
    WarningBox,
    PaymentOption,
    AdjustPax,
    ClaimingReward,
    FormGuestDetail,
    AdditionalServiceProductCart,
    GeneralTopNavbar,
    HotelTopNavbar,
    HotelCheckoutStepper,
  },
  data() {
    return {
      steps: [
        { order: 1, title: 'Your Selection' },
        { order: 2, title: 'Your Details' },
        { order: 3, title: 'Final Step' },
      ],
      currentStep: 2,
      is_order_need_payment: false,
      popup_deposit: false,
      deposit_warning: false,
      terms_conditions: false,
      term_conditions_check: false,
      scrollPosition: null,
      charting: '1',
      popup_active: 'close',
      show_additional_service: false,
      error_additional_service: '',
      is_additional_service_uncategorized: false,
      selected_data_additional_service: {},
      selected_room_rate: {},
      show_booking_for_someone: false,
      contact_type: 'customer',
      push_loading: {
        inquiry: false,
        payment: false,
      },
      cart_view: 'inquiry',
      cart_step: 1,
      tx_inquiry: {},
      payment_surcharge: 0,
      error: {
        inquiry: '',
        payment: '',
        payment_list: '',
      },
      pm: [
        {
          name: 'PayPal',
          desc: '',
          img: paypal,
          height: '28',
          class: 'mt-1',
          code: 'PAYPAL',
        },
        {
          name: 'Credit Card',
          desc: '',
          img: credit_card,
          height: '40',
          class: '',
          code: 'CREDIT_CARD',
        },
        {
          name: 'Bank Transfer',
          desc: '',
          img: bank_transfer,
          height: '40',
          class: '',
          code: 'VIRTUAL_ACCOUNT',
        },
      ],
      payment_methods: [],
      pm_loader: false,
      is_redirect: false,
      dkpayload: new Form({
        MALLID: '',
        BASKET: '',
        CHAINMERCHANT: '',
        AMOUNT: '',
        PURCHASEAMOUNT: '',
        TRANSIDMERCHANT: '',
        WORDS: '',
        REQUESTDATETIME: '',
        CURRENCY: '',
        PURCHASECURRENCY: '',
        SESSIONID: '',
        PAYMENTCHANNEL: '',
        NAME: '',
        EMAIL: '',
        ADDRESS: '',
        COUNTRY: '',
        URL: '',
      }),
      list_additional: '',
      show_xendit_cc_form: false,
      tx_payment: {},
      pm_selected: {},
      payment_option: {},
      payment_option_error: false,
      payment_option_valid: false,
      credit_card_guarantee_id: '',
      adjust_pax: {
        show: false,
        data: {},
      },
      invalid_pax: {
        show: false,
        data: '',
      },
      visitor_form: false,
      visitor_form_valid: true,
      visitor_form_key: 0,
      clear_cart_when_destroyed: false,
      inquiryError:{
        title: '',
        subtitle: ''
      }
    };
  },
  watch: {
    ticket_owner() {
      this.fillDataVisitor();
    },
    term_conditions_check() {
      if (this.term_conditions_check) {
        this.toggleTermsConditions(true);
      }
    },
  },
  computed: {
    ...mapGetters([
      'getMerchant',
      'getBeCart',
      'getBeRoomSubTotal',
      'getBeAddtServiceSubTotal',
      'getIsCartContact',
      'getIsCartVisitor',
      'isNotLogin',
      'getBeFilter',
      'getBeRoomDeposit',
      'getBeAddtServiceDeposit',
      'getAgentId',
      'getBeTxPayment',
      'getSessionLog',
      'getBeRoomTotal',
      'getBeRoomDiscount',
      'getBeRoomTypeSummaryType',
      'getBeBypassCcGuarantee',
      'getBeIsInvalIdPax',
      'getMembershipRewardApplied',
      'isMembershipRewardApplied',
      'getActivityTrxProducts',
      'getOutletTrxProducts',
      'getVoucherOrder',
      'getMembershipReferral',
      'getActivityTrxSubTotal',
      'getOutletTrxSubTotal',
      'getVoucherOrderSubTotal',
      'getActivityTrxPromotion',
      'getOutletTrxPromotion',
      'getVoucherOrderTotalPromo',
      'getActivityTrxTaxService',
      'getOutletTrxTaxService',
    ]),
    totalTaxServiceAdditional(){
      return Number(this.getActivityTrxTaxService) + Number(this.getOutletTrxTaxService)
    },
    subtotalAdditionalService(){
      const subTotal = this.getBeAddtServiceSubTotal + Number(this.getActivityTrxSubTotal) + Number(this.getOutletTrxSubTotal) + Number(this.getVoucherOrderSubTotal)
      
      return subTotal + this.totalTaxServiceAdditional;
    },
    promotionAdditionalService() {
      return (
        Number(this.getActivityTrxPromotion) +
        Number(this.getOutletTrxPromotion) +
        Number(this.getVoucherOrderTotalPromo)
      );
    },
    totalDiscount(){
      return Number(this.getBeRoomDiscount) + Number(this.promotionAdditionalService);
    },
    total_additional_service() {
      let total =
        this.getBeAddtServiceSubTotal + this.$totalAddtServiceModule();
      return total;
    },
    total_price() {
      return this.getBeRoomTotal + this.total_additional_service;
    },
    customer() {
      return this.getBeCart.customer_details;
    },
    guest_name() {
      let data = this.customer.title + '. ' + this.customer.first_name;
      if (this.customer.last_name != null) {
        data += ' ' + this.customer.last_name;
      }
      return data;
    },
    visitor() {
      return this.getBeCart.visitor_details;
    },
    visitor_data() {
      let vuex_data = this.getBeCart.visitor_details;
      let return_data = {
        name: '',
        email: vuex_data.email,
        phone_number: vuex_data.phone_number,
        country:
          this.getMerchant.booking_engine_country != 'HIDE'
            ? vuex_data.country
            : 'HIDE',
        nationality:
          this.getMerchant.booking_engine_nationality != 'HIDE'
            ? vuex_data.nationality
            : 'HIDE',
        date_of_birth:
          this.getMerchant.booking_engine_day_of_birth != 'HIDE'
            ? vuex_data.day_of_birth
            : 'HIDE',
      };

      if (vuex_data.first_name != '') {
        return_data.name = `${this.$capitalize(vuex_data.title)}. ${
          vuex_data.first_name
        }`;
        if (vuex_data.last_name != '')
          return_data.name += ` ${vuex_data.last_name}`;
      }

      return return_data;
    },
    ticket_owner() {
      return this.getBeCart.ticket_owner;
    },
    is_data_valid() {
      return this.getIsCartContact && this.term_conditions_check ? true : false;
    },
    is_data_valid_other() {
      return this.getIsCartVisitor && this.term_conditions_check ? true : false;
    },
    is_payment_valid() {
      let pm_checker = this.payment_methods.filter((x) => x.is_selected);
      return pm_checker.length == 1 ? true : false;
    },
    total_deposit() {
      let total =
        this.getBeRoomDeposit +
        this.getBeAddtServiceDeposit +
        this.$totalAddtServiceModule();
      if (
        Object.keys(this.pm_selected).length > 0 &&
        this.pm_selected.bank_name == 'XENDIT' &&
        this.pm_selected.payment_method == 'CREDIT_CARD'
      ) {
        return Math.ceil(total);
      }
      return total;
    },
    total_deposit_merchant() {
      let total = 0;
      if (this.payment_option.id && this.payment_option.id == 'pay_deposit') {
        let total_amount =
          this.getBeRoomTotal +
          this.getBeAddtServiceSubTotal +
          this.$totalAddtServiceModule();
        total =
          (total_amount * this.getMerchant.deposit_zero_minimum_deposit_value) /
          100;
        total = Math.ceil(total);
      }
      return total;
    },
    total_deposite_display() {
      let total =
        this.total_deposit_merchant > 0
          ? this.total_deposit_merchant
          : this.total_deposit;
      if (this.payment_surcharge > 0) {
        total += this.payment_surcharge;
      }
      return total;
    },
    final_deposit() {
      let total = this.total_deposit;
      if (
        total == 0 &&
        this.payment_option.id &&
        this.payment_option.id == 'pay_deposit'
      ) {
        total = this.total_deposit_merchant;
      }
      return total;
    },
    total_non_deposit() {
      let deposit =
        this.total_deposit_merchant > 0
          ? this.total_deposit_merchant
          : this.total_deposit;
      let total = this.total_price - deposit;
      if (
        Object.keys(this.pm_selected).length > 0 &&
        this.pm_selected.bank_name == 'XENDIT' &&
        this.pm_selected.payment_method == 'CREDIT_CARD'
      ) {
        return Math.ceil(total);
      }
      return total;
    },
    cart_room() {
      return this.getBeCart.room_rate_details;
    },
    totalDate() {
      var diff = 0;
      let check_in = moment(this.getBeFilter.date.check_in).format(
        'YYYY-MM-DD'
      );
      let check_out = moment(this.getBeFilter.date.check_out).format(
        'YYYY-MM-DD'
      );
      diff = moment(check_out).diff(moment(check_in)) / (1000 * 3600 * 24);
      return diff;
    },
    show_guarantee_deposit() {
      if (
        this.getBeBypassCcGuarantee &&
        this.total_deposit <= 0 &&
        (this.getMerchant.deposit_zero_use_cc_guarantee ||
          this.getMerchant.use_changeable_deposit_value)
      ) {
        return true;
      } else {
        return false;
      }
    },
    button_submit_text() {
      let text = '';
      if (
        this.total_deposit == 0 &&
        (!this.payment_option.id ||
          (this.payment_option.id && this.payment_option.id == 'cc_guarantee'))
      ) {
        text = this.$t('hotel.action.book-now');
      } else {
        text = this.$t('hotel.proceed-to-payment');
      }
      return text;
    },
    button_submit_not_valid() {
      return this.ticket_owner == 'me'
        ? !this.is_data_valid
        : !this.is_data_valid_other;
    },
    promo_code_disabled() {
      let return_data = false;
      if (this.getMembershipRewardApplied.id) {
        return_data = true;
      }
      return return_data;
    },
  },
  created() {
    this.$validateActiveReward('HOTEL_PROMOTION');
  },
  destroyed() {
    if (this.clear_cart_when_destroyed) {
      this.clearCart();
    }
  },
  mounted() {
    window.addEventListener('scroll', this.updateScroll);
    document.getElementById('hotel-room-booking').scrollIntoView({
      behavior: 'smooth',
    });
    this.is_order_need_payment = this.total_deposit > 0 ? true : false;

    if (Object.keys(this.getBeTxPayment).length == 0) {
      this.loadFirstData();
    } else {
      this.getPaymentMethodList().then(() => {
        let pm_index = this.payment_methods.findIndex(
          (x) => x.data.id == this.getBeTxPayment.payment_method.id
        );
        if (pm_index != -1) {
          this.togglePayment(pm_index);
        } else {
          let pm_index_2 = this.payment_methods.findIndex(
            (x) =>
              x.data.bank_name == 'XENDIT' &&
              x.data.payment_method == 'CREDIT_CARD'
          );
          if (pm_index_2 != -1) {
            this.togglePayment(pm_index_2);
          }
        }
      });
      this.cart_step = 2;
      this.tx_payment = this.getBeTxPayment;
      this.show_xendit_cc_form = true;
    }
  },
  destroyed() {
    if (this.cart_room.length == 0) {
      this.resetBECart();
    }
  },
  methods: {
    ...mapMutations([
      'setBeTicketOwner',
      'setBeCustomer',
      'setBeVisitor',
      'setActiveRoute',
      'resetBECart',
      'resetBeFilter',
      'setBePayment',
      'setAgentId',
      'setBeTxPayment',
      'setSessionLog',
      'setMembershipRewardApplied',
      'setMembershipReferral',
    ]),
    updateScroll() {
      this.scrollPosition = window.scrollY;
    },
    paymentMethodConverter(payment) {
      return paymentMethodConverter(payment);
    },
    loadFirstData() {
      this.setActiveRoute('');
      if (!this.isNotLogin) {
        this.getUserProfile();
      }
      if (this.cart_step == 2) {
        this.getPaymentMethodList();
      }

      // JOKUL
      let externalScript = document.createElement('script');
      externalScript.setAttribute('src', config.JOKUL_URL);
      document.head.appendChild(externalScript);
    },
    toggleTermsConditions(data) {
      this.terms_conditions = data;
    },
    togglePayment(index) {
      for (let pm in this.payment_methods) {
        this.payment_methods[pm].is_selected = false;
      }
      this.payment_methods[index].is_selected = true;
      let payment_selected = this.payment_methods[index].data;
      this.pm_selected = payment_selected;
      let total = 0;
      if (payment_selected.surcharge_type == 'FIXED_AMOUNT') {
        total = payment_selected.surcharge_value;
      } else {
        total = (this.total_deposit / 100) * payment_selected.surcharge_value;
      }
      this.payment_surcharge =
        payment_selected.bank_name == 'XENDIT' &&
        payment_selected.payment_method == 'CREDIT_CARD'
          ? Math.ceil(total)
          : total;
    },
    togglePopup(data) {
      if (typeof data == 'string') {
        if (!(data == 'promo_code' && this.promo_code_disabled)) {
          this.popup_active = data;
          this.selected_data_additional_service = {};
          if (data == 'visitor_detail') {
            this.contact_type = 'visitor';
          } else {
            this.contact_type = 'customer';
          }
        }
      } else {
        this.popup_active = data.type;
        this.selected_data_additional_service =
          data.type == 'additional_service_service' ? data.data : {};
      }
    },
    toggleAdjustPax(data = false) {
      if (typeof data == 'boolean') {
        this.adjust_pax = {
          show: false,
          data: {},
        };
      } else {
        this.adjust_pax = {
          show: true,
          data: data,
        };
      }
    },
    toggleRoomRateDetail(data = '') {
      this.popup_active = data == '' ? 'close' : 'room_rate';
      this.selected_room_rate = data == '' ? {} : data.room_rate;
    },
    formatCurrency(value) {
      return formatCurrency(value);
    },
    goBeList() {
      this.$router.push({
        path: '/' + this.getMerchant.code + '/booking',
      });
    },
    toggleVisitorForm() {
      this.visitor_form = !this.visitor_form;
      if (this.visitor_form) {
        this.visitor_form_key++;
      }
    },
    fillDataVisitor() {
      if (this.ticket_owner == 'me') {
        this.setBeVisitor(this.getBeCart.customer_details);
        this.show_booking_for_someone = false;
      } else {
        this.setBeVisitor({
          first_name: '',
          last_name: '',
          phone_number: '',
          email: '',
          address: '',
          title: '',
          country: '',
          nationality: '',
          day_of_birth: '',
        });
        this.show_booking_for_someone = true;
      }
    },
    clearCart() {
      this.resetBECart();
      this.resetBeFilter();
      this.setAgentId('');
      this.$clearCartAdditionalService();
    },
    toggleClearCartDestroyed() {
      this.clear_cart_when_destroyed = true;
    },
    toggleInvalidPax() {
      this.invalid_pax.show = !this.invalid_pax.show;
      if (this.invalid_pax.show) {
        let copy_data = this.$deepCopy(this.getBeIsInvalIdPax);
        copy_data = copy_data.map((x) => x.room_rate.name);
        this.invalid_pax.data = copy_data.join();
      } else this.invalid_pax.data = '';
    },
    openAdjustPaxFromWarning() {
      this.toggleInvalidPax();
      this.toggleAdjustPax(this.getBeIsInvalIdPax[0]);
    },
    submitAction() {
      return new Promise((success, fail) => {
        this.$refs.contact_form
          .validateForm()
          .then(() => {
            let ticket_owner = this.getBeCart.ticket_owner;
            let nextStep = () => {
              if (
                this.show_guarantee_deposit &&
                ((this.getMerchant.deposit_zero_use_cc_guarantee &&
                  !this.payment_option.id) ||
                  (this.payment_option.id &&
                    this.payment_option.id == 'cc_guarantee' &&
                    !this.payment_option_valid))
              ) {
                this.payment_option_error = true;
                success();
              } else {
                if (this.getBeIsInvalIdPax.length > 0) {
                  this.toggleInvalidPax();
                  success();
                } else if (this.final_deposit == 0) {
                  this.popup_deposit = 'show';
                  this.error.inquiry = '';
                  success();
                } else {
                  this.submitInquiry().finally(() => {
                    success();
                  });
                }
              }
            };

            if (ticket_owner == 'other') {
              this.$refs.contact_visitor_form
                .validateForm()
                .then(() => {
                  nextStep();
                })
                .catch(() => {
                  this.$smoothScroll('middle-section');
                  this.$postLog('CART', '', 'Got an error on the visitor form');
                  this.visitor_form_valid = false;
                  success();
                });
            } else {
              nextStep();
            }
          })
          .catch(() => {
            this.$smoothScroll('top-section');
            this.$postLog('CART', '', 'Got an error on the contact form');
            fail();
          });
      });
    },

    // API
    getUserProfile() {
      this.tx_inquiry = {};
      get('BASE', 'auth/profile').then((response) => {
        let res = response.data.user;
        let params = {
          first_name: res.first_name,
          last_name: res.last_name,
          email: res.email,
          phone_number: res.phone,
          address: res.address,
          title: res.gender == 'male' ? 'Mr' : 'Mrs',
          country: '',
        };
        this.setBeCustomer(params);
        this.fillDataVisitor();
      });
    },
    getPaymentMethodList() {
      return new Promise((done) => {
        this.pm_loader = true;
        this.error.payment_list = '';
        this.$postLog('PAYMENT', '', 'First Load', this.tx_inquiry.tx_order_id);
        const apiEndPoint = `merchant/${this.getMerchant.code}/payment-method`
        get('CORE_HOTEL', apiEndPoint, {module : 'booking-engine'}).then(
          (response) => {
            let res = response.data;
            if (res.success) {
              const paymentMethodList = res.data.map(payment => {
                const { channel, pg_company } = payment;
                payment.payment_method = payment.channel
                payment.payment_channel = payment.channel
                payment.bank_name = payment.pg_company
                return payment;
              })
              for (let pm of paymentMethodList) {
                let item = {
                  data: pm,
                  is_selected: false,
                };
                this.payment_methods.push(item);
              }
            } else {
              this.error.payment_list = res.message;
            }
            done();
            this.pm_loader = false;
          }
        );
      });
    },
    hitGogleAnalytics(event) {
      if (this.getMerchant.google_analytics_id != null) {
        if (this.getMerchant.google_analytics_id != '') {
          this.$gtag('event',event, { method: 'Google' });
        }
      }
    },
    submitWithZeroDeposit() {
      return new Promise((success, fail) => {
        if (
          this.show_guarantee_deposit &&
          this.final_deposit <= 0 &&
          this.getMerchant.deposit_zero_use_cc_guarantee &&
          this.payment_option.id == 'cc_guarantee'
        ) {
          this.$refs.payment_option
            .submitCC()
            .then(() => {
              this.submitInquiry().finally(() => {
                success();
              });
            })
            .catch((err) => {
              if (err == 'room-not-available') {
                this.error.inquiry = 'room not available';
                this.push_loading.inquiry = false;
              }
              success();
            });
        } else {
          this.submitInquiry().finally(() => {
            success();
          });
        }
      });
    },
    getInquiryParam() {
      let params = {
        merchant_id: this.getMerchant.id,
        room_rate_details: [],
        customer_details: JSON.parse(
          JSON.stringify(this.getBeCart.customer_details)
        ),
        additional_service_details: [],
        special_request_details: [],
        notes: this.getBeCart.note,
        custom_check_in_time: this.getBeCart.custom_time.check_in,
        custom_check_out_time: this.getBeCart.custom_time.check_out,
        region: 'Indonesia',
        device: 'mobile',
        agent_id: this.getAgentId,
        use_promotion_combine: true,
      };

      if (this.$isNotEmptyV2(this.getMembershipReferral)) {
        params.membership_referral_code =
          this.getMembershipReferral.membership_referral_code;
        params.membership_reward_id =
          this.getMembershipReferral.membership_reward_id;
      } else if (!this.isNotLogin && this.getMembershipRewardApplied.id) {
        params.membership_reward_id = this.getMembershipRewardApplied.id;
      }

      if (this.ticket_owner == 'other') {
        params.visitor_details = JSON.parse(
          JSON.stringify(this.getBeCart.visitor_details)
        );
        params.visitor_details.address = '';
      }
      params.customer_details.address = '';

      if (this.getBeFilter.promo_code != '') {
        params.promo_code = this.getBeFilter.promo_code;
      }
      for (let room of this.getBeCart.room_rate_details) {
        for (let i = 0; i < room.qty; i++) {
          let guest = room.guest[i];
          let room_item = {
            check_in_date: moment(this.getBeFilter.date.check_in).format(
              'YYYY-MM-DD'
            ),
            check_out_date: moment(this.getBeFilter.date.check_out).format(
              'YYYY-MM-DD'
            ),
            qty: 1,
            room_rate_id: room.room_rate.id_ori,
            adult: guest.included.adult + guest.extra.adult,
            child: guest.included.child + guest.extra.child,
            infant: guest.included.infant + guest.extra.infant,
            promo_combine_id:
              room.room_rate.best_price.promo_combine != null
                ? room.room_rate.best_price.promo_combine.id
                : null,
          };
          params.room_rate_details.push(room_item);
        }
      }
      for (let special_request of this.getBeCart.special_request) {
        let special_request_item = {
          id: special_request.data.id,
          notes: special_request.note,
        };
        params.special_request_details.push(special_request_item);
      }

      // ADDITIONAL SERVICE
      for (let addt_service of this.getBeCart.additional_service) {
        let addt_service_item = {
          id: addt_service.data.id,
          qty: addt_service.qty,
          date: moment(this.getBeFilter.date.check_in).format('YYYY-MM-DD'),
        };
        params.additional_service_details.push(addt_service_item);
      }

      let total_product_addt_other_module =
        this.getActivityTrxProducts.length +
        this.getOutletTrxProducts.length +
        this.getVoucherOrder.cart.length;

      if (total_product_addt_other_module > 0) {
        params.tx_merchant_pos = [];

        // SPA/ACTIVITY
        this.getActivityTrxProducts.forEach((activity) => {
          let {
            original_data: { product_merchant_pos, product_ga_pos_id },
            service_time,
            service_date,
            therapist_gender,
            place_choice,
          } = activity;

          let setupProduct = () => {
            let sub_param = {
              id: product_ga_pos_id,
              qty: activity.qty,
              notes: '',
              schedule_id: service_time.id ? service_time.id : null,
              service_date: moment(service_date).format('YYYY-MM-DD'),
              therapist_gender,
              place_choice,
            };
            let time = moment(service_time.schedule_start, 'HH:mm:ss').format(
              'HH:mm'
            );
            sub_param.service_date += ` ${time}`;

            return sub_param;
          };

          let tx_merchant_pos_index = params.tx_merchant_pos.findIndex(
            (x) => x.merchant_pos_id == product_merchant_pos[0].id
          );
          if (tx_merchant_pos_index != -1) {
            params.tx_merchant_pos[tx_merchant_pos_index].products.push(
              setupProduct()
            );
          } else {
            params.tx_merchant_pos.push({
              merchant_pos_id: product_merchant_pos[0].id,
              products: [setupProduct()],
            });
          }
        });

        // OUTLET
        this.getOutletTrxProducts.forEach((outlet) => {
          let { product_pos, product_merchant_pos, product_ga_pos_id } =
            outlet.product_data;

          let is_variant = outlet.variants.length > 0;

          let setupProduct = (id, qty, note) => {
            let sub_param = {
              id: id,
              qty: qty,
              notes: note,
              service_date: moment(this.getBeFilter.date.check_in).format(
                'YYYY-MM-DD'
              ),
            };
            let time = moment(
              this.getMerchant.check_in_time_start,
              'HH:mm:ss'
            ).format('HH:mm');
            sub_param.service_date += ` ${time}`;

            return sub_param;
          };

          if (is_variant) {
            let tx_merchant_pos_index = params.tx_merchant_pos.findIndex(
              (x) => x.merchant_pos_id == product_pos[0].id
            );
            outlet.variants.forEach((variant) => {
              let sub_param = setupProduct(
                variant.variant_data.product_ga_pos_id,
                variant.qty,
                variant.notes
              );
              if (tx_merchant_pos_index != -1) {
                params.tx_merchant_pos[tx_merchant_pos_index].products.push(
                  sub_param
                );
              } else {
                params.tx_merchant_pos.push({
                  merchant_pos_id: product_pos[0].id,
                  products: [sub_param],
                });
              }
            });
          } else {
            let tx_merchant_pos_index = params.tx_merchant_pos.findIndex(
              (x) => x.merchant_pos_id == product_merchant_pos[0].id
            );
            let sub_param = setupProduct(
              product_ga_pos_id,
              outlet.qty,
              outlet.notes
            );
            if (tx_merchant_pos_index != -1) {
              params.tx_merchant_pos[tx_merchant_pos_index].products.push(
                sub_param
              );
            } else {
              params.tx_merchant_pos.push({
                merchant_pos_id: product_merchant_pos[0].id,
                products: [sub_param],
              });
            }
          }
        });

        // VOUCHER
        this.getVoucherOrder.cart.forEach((voucher_parent) => {
          voucher_parent.product.forEach((voucher) => {
            let { data, is_variant, variant_list, notes, qty } = voucher;

            let setupProduct = (id, qty, note) => {
              let sub_param = {
                id: id,
                qty: qty,
                notes: note,
                service_date: moment(this.getBeFilter.date.check_in).format(
                  'YYYY-MM-DD'
                ),
              };
              let time = moment(
                this.getMerchant.check_in_time_start,
                'HH:mm:ss'
              ).format('HH:mm');
              sub_param.service_date += ` ${time}`;

              return sub_param;
            };

            let tx_merchant_pos_index = params.tx_merchant_pos.findIndex(
              (x) => x.merchant_pos_id == data.merchant_pos.id
            );

            if (is_variant) {
              variant_list.forEach((variant) => {
                let sub_param = setupProduct(
                  variant.data.product_ga_pos_id,
                  variant.qty,
                  variant.notes
                );
                if (tx_merchant_pos_index != -1) {
                  params.tx_merchant_pos[tx_merchant_pos_index].products.push(
                    sub_param
                  );
                } else {
                  params.tx_merchant_pos.push({
                    merchant_pos_id: data.merchant_pos.id,
                    products: [sub_param],
                  });
                }
              });
            } else {
              let sub_param = setupProduct(data.product_ga_pos_id, qty, notes);
              if (tx_merchant_pos_index != -1) {
                params.tx_merchant_pos[tx_merchant_pos_index].products.push(
                  sub_param
                );
              } else {
                params.tx_merchant_pos.push({
                  merchant_pos_id: data.merchant_pos.id,
                  products: [sub_param],
                });
              }
            }
          });
        });
      }

      const membershipRewardId = this.$generateRewardIdRoomPromotion();
      if(this.$isNotEmptyV2(membershipRewardId)){
        params.membership_reward_id = membershipRewardId;
      }
      
      return params;
    },

    submitInquiry() {
      return new Promise((success, fail) => {
        this.$postLog('CART', '', 'Clicked Proceed to Payment');
        this.hitGogleAnalytics('booking');
        this.push_loading.inquiry = true;
        this.error = {
          inquiry: '',
          payment: '',
        };
        let params = this.getInquiryParam();
        post('CORE_HOTEL', 'tx-inquiry', params).then((response) => {
          let res = response.data;
          if (res.success) {
            this.tx_inquiry = res;
            this.$postLog(
              'CART',
              '',
              'Inquiry Success',
              this.tx_inquiry.tx_order_id
            );
            this.sendToMetaCAPI('InitiateCheckout', res);
            if (this.final_deposit > 0) {
              this.getPaymentMethodList().then(() => {
                this.cart_step = 2;
                document.getElementById('hotel-room-booking').scrollIntoView({
                  behavior: 'smooth',
                });
              });
              this.push_loading.inquiry = false;
              success();
            } else {
              this.submitPayment().finally(() => {
                success();
              });
            }
          } else {
            this.error.inquiry = res.message;
            this.parsingInquiryErrorMessage(res.message)
            this.popup_deposit = false;
            this.push_loading.inquiry = false;
            success();
          }
        });
      });
    },
    toggleStep(data) {
      this.cart_step = data;
    },
    submitPayment() {
      return new Promise((done, fail) => {
        if (
          this.is_payment_valid ||
          this.tx_inquiry.data.payments.total_deposit == 0
        ) {
          this.$postLog(
            'PAYMENT',
            '',
            'Clicked Payment',
            this.tx_inquiry.tx_order_id
          );
          this.hitGogleAnalytics('payment');
          this.push_loading.payment = true;
          let params = {
            tx_order_id: this.tx_inquiry.tx_order_id,
            payment_details: {},
            use_promotion_combine: true,
            total_deposit: Math.round(this.final_deposit),
            channex_pci_id: !(
              this.credit_card_guarantee_id == '' ||
              this.credit_card_guarantee_id == 'error'
            )
              ? this.credit_card_guarantee_id
              : null,
          };

          if (this.$isNotEmptyV2(this.getMembershipReferral)) {
            params.membership_referral_code =
              this.getMembershipReferral.membership_referral_code;
            params.membership_reward_id =
              this.getMembershipReferral.membership_reward_id;
          } else if (!this.isNotLogin && this.getMembershipRewardApplied.id) {
            params.membership_reward_id = this.getMembershipRewardApplied.id;
          }

          let selected_payment =
            this.payment_methods.length == 0
              ? null
              : this.payment_methods.find((x) => x.is_selected);
          if (this.final_deposit > 0) {
            params.payment_details = {
              id: selected_payment.data.id,
              payment_method: selected_payment.data.payment_method,
              bank_name: selected_payment.data.bank_name,
              payment_channel: selected_payment.data.payment_method,
            };
          }

          const membershipRewardId = this.$generateRewardIdRoomPromotion();
          if(this.$isNotEmptyV2(membershipRewardId)){
            params.membership_reward_id = membershipRewardId;
          }

          post('CORE_HOTEL', 'tx-payment', params).then((response) => {
            let res = response.data;
            if (res.success) {
              this.$postLog(
                'PAYMENT',
                '',
                'Payment Success',
                this.tx_inquiry.tx_order_id
              );
              if(this.final_deposit > 0) {
                const metaCapiParams = {
                  payment_method_selected: selected_payment.data.name,
                  ...this.tx_inquiry
                }
                this.sendToMetaCAPI('AddPaymentInfo', metaCapiParams)
              }
              if (this.getSessionLog.saved_id != this.tx_inquiry.tx_order_id) {
                this.setSessionLog([
                  {
                    key: 'session',
                    value: this.$createUUID(),
                  },
                  {
                    key: 'saved_id',
                    value: this.tx_inquiry.tx_order_id,
                  },
                ]);
              }

              if (this.$isNotEmptyV2(this.getMembershipReferral))
                this.setMembershipReferral({});
              else if (!this.isNotLogin && this.getMembershipRewardApplied.id)
                this.setMembershipRewardApplied({});

              if (
                res.payment == null ||
                this.tx_inquiry.data.payments.total_deposit == 0 ||
                selected_payment == null ||
                selected_payment.data.bank_name == 'BPD_BALI'
              ) {
                this.clear_cart_when_destroyed = true;
                this.$router.push({
                  name: 'BePaymentResult',
                  params: {
                    tx_order_id: this.tx_inquiry.tx_order_id,
                  },
                  query:{
                    tx_sk: res.tx_sk
                  }
                });
              } else if (selected_payment.data.bank_name == 'JOKUL_DOKU') {
                if (selected_payment.data.payment_method == 'VIRTUAL_ACCOUNT') {
                  this.clear_cart_when_destroyed = true;
                  this.$router.push({
                    name: 'BePaymentResult',
                    params: {
                      tx_order_id: this.tx_inquiry.tx_order_id,
                    },
                    query:{
                      tx_sk: res.payment.tx_sk
                    }
                  });
                } else {
                  this.clear_cart_when_destroyed = true;
                  loadJokulCheckout(res.payment.url);
                }
              } else if (selected_payment.data.bank_name == 'DOKU') {
                this.clear_cart_when_destroyed = true;
                this.is_redirect = true;
                this.dkpayload.MALLID = res.payment.form.MALLID;
                this.dkpayload.CHAINMERCHANT = res.payment.form.CHAINMERCHANT;
                this.dkpayload.AMOUNT = res.payment.form.AMOUNT;
                this.dkpayload.PURCHASEAMOUNT = res.payment.form.PURCHASEAMOUNT;
                this.dkpayload.TRANSIDMERCHANT =
                  res.payment.form.TRANSIDMERCHANT;
                this.dkpayload.WORDS = res.payment.form.WORDS;
                this.dkpayload.REQUESTDATETIME =
                  res.payment.form.REQUESTDATETIME;
                this.dkpayload.CURRENCY = res.payment.form.CURRENCY;
                this.dkpayload.PURCHASECURRENCY =
                  res.payment.form.PURCHASECURRENCY;
                this.dkpayload.SESSIONID = res.payment.form.SESSIONID;
                this.dkpayload.PAYMENTCHANNEL = res.payment.form.PAYMENTCHANNEL;
                this.dkpayload.COUNTRY = res.payment.form.COUNTRY;
                this.dkpayload.NAME = res.payment.form.NAME;
                this.dkpayload.EMAIL = res.payment.form.EMAIL;
                this.dkpayload.ADDRESS = res.payment.form.ADDRESS;
                this.dkpayload.MOBILEPHONE = res.payment.form.MOBILEPHONE;
                this.dkpayload.BASKET = res.payment.form.BASKET;
                this.dkpayload.URL = res.payment.payment_url;
                this.$nextTick(() => {
                  this.$refs.FormDKload.submit();
                });
              } else if (selected_payment.data.bank_name == 'MIDTRANS') {
                this.clear_cart_when_destroyed = true;
                let scriptTag = document.createElement('script');
                scriptTag.src = config.MIDTRANS_URL;
                scriptTag.setAttribute(
                  'data-client-key',
                  res.payment.client_key
                );
                document.head.appendChild(scriptTag);
                scriptTag.onload = function () {
                  window.snap.pay(res.payment.token);
                };
              } else if (
                selected_payment.data.bank_name == 'XENDIT' &&
                selected_payment.data.payment_method == 'CREDIT_CARD'
              ) {
                this.setBeTxPayment(res.payment);
                this.tx_payment = res.payment;
                this.show_xendit_cc_form = true;
                document.getElementById('hotel-room-booking').scrollIntoView({
                  behavior: 'smooth',
                });
              } else if (
                selected_payment.data.bank_name == 'XENDIT_INTERNATIONAL' &&
                selected_payment.data.payment_method == 'DIRECT_DEBIT'
              ) {
                this.$openLink(res.payment.url_redirect);
              } else if (
                selected_payment.data.bank_name == 'IPAYMU' &&
                selected_payment.data.payment_method == 'CREDIT_CARD'
              ) {
                this.clear_cart_when_destroyed = true;
                this.$openLink(res.payment.url);
              } else if (selected_payment.data.bank_name == 'CASHLEZ') {
                this.clear_cart_when_destroyed = true;
                let new_tab_type =
                  selected_payment.data.pg_mode == 'PG_HOSTED'
                    ? 'default'
                    : '_blank';
                this.$openLink(res.payment.url, new_tab_type);
                if (selected_payment.data.pg_mode == 'MERCHANT_HOSTED') {
                  this.$router.push({
                    name: 'BePaymentResult',
                    params: {
                      tx_order_id: this.tx_inquiry.tx_order_id,
                    },
                    query:{
                      tx_sk: res.payment.tx_sk
                    }
                  });
                }
              } else if (
                selected_payment.data.bank_name == 'MALDIVE_BANK' &&
                selected_payment.data.payment_channel == 'CREDIT_CARD'
              ) {
                this.clear_cart_when_destroyed = true;
                this.$openLink(res.payment.url_redirect);
              }else {
                this.clear_cart_when_destroyed = true;
                this.$router.push({
                  name: 'BePaymentResult',
                  params: {
                    tx_order_id: this.tx_inquiry.tx_order_id,
                  },
                  query:{
                    tx_sk: res.payment.tx_sk
                  }
                });
              }
            } else {
              this.error.payment = res.message;
              // this.error.inquiry = 'invalid tx id'
              if (this.cart_step == 1) {
                this.popup_deposit = false;
              }
            }
            this.push_loading.inquiry = false;
            this.push_loading.payment = false;
            done();
          });
        } else {
          done();
        }
      });
    },
    sendToMetaCAPI(eventName, inquiry){
      const params = {
        tx_order_id: inquiry.tx_order_id,
        ...inquiry.data,
        payment_method_selected: inquiry.payment_method_selected ? inquiry.payment_method_selected : null
      }

      this.$sendEventMetaConversionsAPI(eventName, params);
    },
    parsingInquiryErrorMessage(message){
      if (message === 'invalid tx id') {
        this.inquiryError = {
          title: this.$t('hotel.error.invalid tx id'),
          subtitle: this.$t('hotel.error.confirm-again-desc')
        }
      } else if (message === 'invalid check_in_date') {
        this.inquiryError = {
          title: this.$t('hotel.error.invalid check_in_date'),
          subtitle: this.$t('hotel.Please choose another date')
        }
      } else {
        this.inquiryError = {
          title: "Something went wrong",
          subtitle: `Error detail : ${message}`
        }
      }
    },
    clearPaymentError() {
      this.error.payment = '';
    },
    closeXenditCC() {
      this.tx_payment = {};
      this.show_xendit_cc_form = false;
      this.loadFirstData();
    },
    reloadPage() {
      location.reload();
    },
    redirectReset() {
      this.resetBECart();
      this.$router.push({
        path: '/' + this.getMerchant.code + '/booking',
      });
    },
    submitPaymentOption(data) {
      this.payment_option = data;
      this.is_order_need_payment = data.id == 'pay_deposit' ? true : false;
    },
    changeStatusCC(data) {
      this.payment_option_valid = data;
    },
    getCreditCardId(data) {
      if (data == 'error') {
        this.payment_option_error = true;
      } else {
        this.credit_card_guarantee_id = data;
      }
    },
    resetSavedReward() {
      this.setMembershipRewardApplied({});
      this.resetBECart();
      this.$router.push(`/${this.getMerchant.code}/booking`);
    },
    saveVisitorForm() {
      return new Promise((success, fail) => {
        setTimeout(() => {
          this.$refs.contact_visitor_form
            .validateForm()
            .then(() => {
              this.toggleVisitorForm();
              success();
            })
            .catch(() => fail());
        }, 300);
      });
    },
  },
};
</script>
<style scoped>
.w-img-login {
  width: 40px;
  height: 40px;
}

@media screen and (max-width: 345px) {
  .w-img-login {
    width: 25px;
    height: 25px;
    top: 5px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/hotel/be/BeCartMobile.vue